import { render, staticRenderFns } from "./LocaleDropdown.vue?vue&type=template&id=a41b6d5a&scoped=true&lang=pug"
import script from "./LocaleDropdown.vue?vue&type=script&lang=js"
export * from "./LocaleDropdown.vue?vue&type=script&lang=js"
import style0 from "./LocaleDropdown.vue?vue&type=style&index=0&id=a41b6d5a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a41b6d5a",
  null
  
)

export default component.exports